import type {PermissionCatalogEntry} from './permissionGrouping'
import {canonicalizeRolePermissionCode} from './rolePermissionCanonicalization'

export const GRANT_DENIED_REASON =
  'Your role does not have this permission. Ask Superadmin to enable it first.'

export function buildGrantableByCodeMap(
  catalog: PermissionCatalogEntry[],
  actorIsSuperAdmin: boolean
): Map<string, boolean> {
  const map = new Map<string, boolean>()
  if (actorIsSuperAdmin) {
    return map
  }
  catalog.forEach((entry) => {
    const code = canonicalizeRolePermissionCode(entry.permissionCode || '')
    if (!code) return
    map.set(code, (entry as any).grantableByActor === true)
  })
  return map
}

export function isGrantablePermissionCode(
  code: string,
  grantableByCode: Map<string, boolean>,
  actorIsSuperAdmin: boolean
): boolean {
  if (actorIsSuperAdmin) return true
  const canonical = canonicalizeRolePermissionCode(code)
  if (!canonical) return false
  if (!grantableByCode.has(canonical)) {
    return false
  }
  return grantableByCode.get(canonical) !== false
}

export function grantDeniedReasonFor(
  code: string,
  catalog: PermissionCatalogEntry[]
): string {
  const canonical = canonicalizeRolePermissionCode(code)
  const entry = catalog.find(
    (row) => canonicalizeRolePermissionCode(row.permissionCode || '') === canonical
  )
  return (entry as any)?.grantDeniedReason || GRANT_DENIED_REASON
}
